import React from 'react';
import { useAuth } from 'react-oidc-context';
import { SettingsControls } from '../SettingsControls';

const SubcategorySelectionPanel = () => {
  const auth = useAuth();
  const token = auth.user?.access_token;

  if (!auth.isAuthenticated || !token) return null;

  return (
    <SettingsControls
      token={token}
      onClose={() => {}}
      onApplied={() => window.location.reload()}
      variant="secondary"
    />
  );
};

export { SubcategorySelectionPanel };
